import React from 'react'
import "./Footer.css"

const Footer = () => {
  return (
    <div className='footer'>
        © 2024 boAt
    </div>
  )
}

export default Footer